export default {
  EmptyState: {
    title: 'Agrega tu primer restaurante',
    description: 'Aún no tienes restaurantes. Crea uno para empezar a configurarlo y recibir pedidos.',
    cta: 'Nuevo restaurante',
  },
};
